/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: Omit<EmployeeFileCatalog, \'id\' | \'createdBy\' | \'modifiedBy\' | \'createdOn\' | \'modifiedOn\' | \'deleted\' | \'deletedBy\' | \'deletedOn\'>, schemaOptions: { title: \'NewEmployeeFileCatalog\', exclude: [ \'id\', \'createdBy\', \'modifiedBy\', \'createdOn\', \'modifiedOn\', \'deleted\', \'deletedBy\', \'deletedOn\' ] })
 */
export interface NewEmployeeFileCatalog { 
    code: string;
    name: string;
    description?: string;
    isRequired?: boolean;
    displayOrder?: number;
    isActive?: boolean;
}

